import { alertError } from './../store/alert/actions';
import { apiUrl } from './../index';
import axios from 'axios';

export const uploadImage = (type: string, file: File, data: FormData) => {
  data.append('image', file);

  return axios.post(`${apiUrl}/upload/${type}`, data, {
    headers: {
      'Content-Type': `multipart/form-data`
    }
  });
};

export const validateFile = (dispatch: any, file: File) => {
  if (file && file.size / 1024 / 1024 > 3) {
    dispatch(alertError(new Error('Bildgröße maximal 3 MB')));
    return false;
  } else if (file && file.type !== 'image/jpeg') {
    dispatch(alertError(new Error(`Bildformat ${file.type} nicht unterstützt (nur .jpg/.jpeg)`)));
    return false;
  }
  return true;
};



// WEBPACK FOOTER //
// ./src/utils/imageHelper.ts